import React, { FC, useEffect } from 'react';

import './DesktopApp.scss';

import * as BIManager from '../../utils/bi';
import { fedopsLogger } from '../../utils/fedops-logger';
import { initDealer } from '../../utils/initDealer';

import { EditorXToolBar } from '../partials/EditorXToolBar/EditorXToolBar';
import { EditorXTemplateDemo } from '../EditorXTemplateDemo/EditorXTemplateDemo';
import { InfoPopUp } from '../InfoPopUp/InfoPopUp';
import { TemplateDemo } from '../TemplateDemo/TemplateDemo';
import { ToolBar } from '../ToolBar/ToolBar';

import { useTemplateContext } from '../../context/TemplateContext/TemplateContext';
import { useUIContext } from '../../context/UIContext/UIContext';
import { useConfigContext } from '../../context/ConfigContext/ConfigContext';

export const DesktopApp: FC = () => {
  const { viewMode, toggleViewMode, isInfoShown } = useUIContext();
  const { template } = useTemplateContext();
  const { lang, dealerCmsTranslationsUrl, dealerLightboxUrl } = useConfigContext();
  const { isResponsive, editorSessionId, siteId, metaSiteId } = template;

  useEffect(() => {
    BIManager.reportLoadSuccess();
    if (isResponsive) {
      BIManager.reportResponsiveTemplateLoaded();
    }
    fedopsLogger.appLoaded();

    initDealer({
      editorSessionId,
      metaSiteId,
      siteId,
      lang,
      dealerCmsTranslationsUrl,
      dealerLightboxUrl,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.getElementsByTagName('body')[0].classList.toggle('popup', isInfoShown);
  }, [isInfoShown]);

  return (
    <div data-hooks="app">
      {template.isResponsive ? (
        <>
          <EditorXToolBar template={template} viewMode={viewMode} toggleViewMode={toggleViewMode} />
          <EditorXTemplateDemo template={template} viewMode={viewMode} />
        </>
      ) : (
        <>
          <ToolBar />
          <TemplateDemo />
        </>
      )}
      <InfoPopUp />
    </div>
  );
};
